/*
  Animorix – animated header logo.
  Turns an inline Animorix SVG logo into an entrance animation: letters drop in one by one, the heart on the "i"
  pops and beats, the paw toes pop and the pad stamps down. ~1.5 s, plays once per browser session,
  skipped entirely with prefers-reduced-motion. Works with the pink and the white (transparent header) logo.
*/
(() => {
  const KEY = 'axLogoPlayed';
  const css = `
    .ax-logo-anim .ax-l { transform-box: fill-box; transform-origin: 50% 100%; animation: ax-l-drop .62s cubic-bezier(.34,1.56,.64,1) both; }
    .ax-logo-anim .ax-h { transform-box: fill-box; transform-origin: 50% 60%; animation: ax-h-pop .5s cubic-bezier(.34,1.8,.64,1) both, ax-h-beat .7s ease-in-out .5s 2; }
    .ax-logo-anim .ax-t { transform-box: fill-box; transform-origin: 50% 50%; animation: ax-pop .42s cubic-bezier(.34,1.8,.64,1) both; }
    .ax-logo-anim .ax-p { transform-box: fill-box; transform-origin: 50% 50%; animation: ax-stamp .45s cubic-bezier(.2,.7,.2,1) both; }
    @keyframes ax-l-drop { 0% { opacity: 0; transform: translateY(-55%) scale(1, 1.08); } 55% { opacity: 1; } 78% { transform: translateY(0) scale(1.1, .9); } 100% { opacity: 1; transform: none; } }
    @keyframes ax-h-pop { 0% { opacity: 0; transform: scale(0); } 100% { opacity: 1; transform: scale(1); } }
    @keyframes ax-h-beat { 0%, 100% { transform: scale(1); } 30% { transform: scale(1.3); } 60% { transform: scale(.95); } }
    @keyframes ax-pop { 0% { opacity: 0; transform: scale(0); } 100% { opacity: 1; transform: scale(1); } }
    @keyframes ax-stamp { 0% { opacity: 0; transform: scale(1.7); } 60% { opacity: 1; transform: scale(.92); } 100% { opacity: 1; transform: scale(1); } }
    @media (prefers-reduced-motion: reduce) { .ax-logo-anim * { animation: none !important; } }`;

  function split(svg) {
    const ns = 'http://www.w3.org/2000/svg';
    const groups = [...svg.children].filter((g) => g.tagName === 'g');
    const paw = groups.find((g) => g.querySelector('ellipse'));
    const letterLayers = groups.filter((g) => g !== paw);
    // Measure the letter sub-paths once (on the first layer) and group them into letters (holes join their letter).
    let letterIdx = null;
    letterLayers.forEach((layer) => {
      const paths = [...layer.querySelectorAll(':scope > path')].sort((a, b) => b.getAttribute('d').split('M').length - a.getAttribute('d').split('M').length);
      const [letters, heart] = paths;
      if (heart) heart.classList.add('ax-h');
      if (!letters) return;
      const subs = letters.getAttribute('d').split(/(?=M)/).filter(Boolean);
      if (!letterIdx) {
        const boxes = subs.map((d) => { const p = document.createElementNS(ns, 'path'); p.setAttribute('d', d); svg.appendChild(p); const b = p.getBBox(); p.remove(); return b; });
        const L = [];
        boxes.forEach((b, i) => {
          const host = L.find((x) => b.x >= x.x - 1 && b.x + b.width <= x.x + x.width + 1 && b.y >= x.y - 1 && b.y + b.height <= x.y + x.height + 1);
          host ? host.idx.push(i) : L.push({ x: b.x, y: b.y, width: b.width, height: b.height, idx: [i] });
        });
        L.sort((a, b) => a.x - b.x); letterIdx = L.map((x) => x.idx);
      }
      letterIdx.forEach((idx, n) => {
        const p = document.createElementNS(ns, 'path');
        p.setAttribute('d', idx.map((i) => subs[i] || '').join('')); p.classList.add('ax-l'); p.style.animationDelay = (n * 0.05) + 's';
        layer.insertBefore(p, letters);
      });
      letters.remove();
    });
    if (heart0(svg)) heart0(svg).forEach((h) => { h.style.animationDelay = '.5s, 1s'; });
    if (paw) {
      paw.querySelectorAll('ellipse').forEach((e, i) => { e.classList.add('ax-t'); e.style.animationDelay = (0.62 + i * 0.07) + 's'; });
      const pad = paw.querySelector('path'); if (pad) { pad.classList.add('ax-p'); pad.style.animationDelay = '.92s'; }
    }
  }
  const heart0 = (svg) => [...svg.querySelectorAll('.ax-h')];

  function run(force) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let played = false; try { played = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (played && !force) return;
    if (!document.getElementById('ax-logo-anim-css')) { const s = document.createElement('style'); s.id = 'ax-logo-anim-css'; s.textContent = css; document.head.appendChild(s); }
    document.querySelectorAll('svg[data-ax-logo]').forEach((svg) => {
      if (svg.dataset.axDone) return; svg.dataset.axDone = '1';
      if (!svg.getBoundingClientRect().width) return;   // hidden variant (e.g. transparent logo while header is filled): leave static
      split(svg); svg.classList.add('ax-logo-anim');
    });
    try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
  }
  window.axLogoAnim = run;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run()); else run();
})();
